import {
  getOneXpExperiments,
  hasOneXpRequestFinished
} from 'src/universal/redux/oneXp';
import parseArrayToObject from 'src/universal/utils/parseArrayToObject';
import queryString from 'query-string';
import { isBrowser } from 'acq-utils/lib/misc';
import { getExperimentalPageData } from 'src/universal/redux/page';
import { createSelector } from 'reselect';

export const isG179Variant = createSelector(
  [getOneXpExperiments],
  oneXpExperiments => {
    return (
      oneXpExperiments['GCS-179-PDP-Affiliate-Journey']?.dimensions[0]?.variant ===
      'experiment'
    );
  }
);

export const getCombinedG179Data = createSelector(
  [isG179Variant, hasOneXpRequestFinished, getExperimentalPageData],
  (g179Variant, oneXpDecided, { g179AffiliateFlow }) => {
    /*
    the 3 factors that determine the isAffiliatePgMode: 
    (a) oneXp arrived
    (b) isG179Variant
    (c) we have the matching banner data
    */
    const affIdMap = parseArrayToObject(g179AffiliateFlow?.assets, 'id');
    const parsedQuery = queryString.parseUrl(isBrowser() ? location.href : '');
    const affId = (parsedQuery?.query || {}).affid || '';
    const matchedItem = affIdMap[affId];
    const isAffiliatePgMode = oneXpDecided && g179Variant && !!matchedItem;

    const bannerData = {
      bannerTitle: g179AffiliateFlow?.bannerTitle,
      bannerAmexLogo: g179AffiliateFlow?.bannerAmexLogo,
      ...matchedItem
    };

    return {
      isG179Variant: g179Variant,
      isAffiliatePgMode,
      oneXpDecided,
      bannerData
    };
  }
);
